import { render, staticRenderFns } from "./zhiyeku_mobile.vue?vue&type=template&id=4c0760a3&scoped=true"
import script from "./zhiyeku_mobile.vue?vue&type=script&lang=js"
export * from "./zhiyeku_mobile.vue?vue&type=script&lang=js"
import style0 from "./zhiyeku_mobile.vue?vue&type=style&index=0&id=4c0760a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0760a3",
  null
  
)

export default component.exports